import AuthAxios from '../../models/Axios'
import * as Types from '../../constants/actionTypes';
import { LOCAL_URL, API_REQUESTS } from '../../helper/constant'



export const GET_LIST_INQUIRY = (payload) => async (dispatch) => {
  try {
   const data = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.INQUIRY}/getListInquiryClient`, { params: payload });
   return data?.data
  } catch (exception) {
    dispatch({
      type: Types.REQUEST_LIST_INQUIRY_ERROR,
      error:exception.message
    })
  }
}

export const GET_LIST_INQUIRY_STATUS = (payload) => async (dispatch) => {
  try {
   const data = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.INQUIRY}/getListInquiryStatus`, { params: payload });
   return data?.data?.data?.data
  } catch (exception) {
    dispatch({
      type: Types.REQUEST_LIST_INQUIRY_STATUS_ERROR,
      error:exception.message
    })
  }
}

export const GET_LIST_INQUIRY_TRACKING_STATUS = (payload) => async (dispatch) => {
  try {
   const data = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.INQUIRY}/getListInquiryTrackingStatus`, { params: payload });
   return data?.data?.data?.data
  } catch (exception) {
    dispatch({
      type: Types.REQUEST_LIST_INQUIRY_TRACKING_STATUS_ERROR,
      error:exception.message
    })
  }
}

export const GET_INQUIRY_TRACKING_STATUS_HISTORY = (payload) => async (dispatch) => {
  try {
    const data = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.INQUIRY}/getTrackingStatusHistoryByInquiryId/${payload.id}`);
    return data?.data?.data
  } catch (exception) {
    return exception;
  }
}


export const GET_LIST_INQUIRY_CATEGORY = (payload) => async (dispatch) => {
  try {
   const data = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.INQUIRY_CATEGORIES}`, { params: payload });
   dispatch({ type: Types.GET_LIST_INQUIRY_CATEGORY_SUCCESS, payload: data.data?.data });
   return data.data?.data;
  } catch (exception) {
    dispatch({
      type: Types.REQUEST_LIST_INQUIRY_ERROR,
      error:exception.message
    })
  }
}

export const GET_PORTAL_INQUIRY_CATEGORIES = (payload) => async (dispatch) => {
    try {
        const data = (await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.PORTAL_INQUIRY_CATEGORIES}`, { params: payload })).data?.data.map((i) => ({
            ...i.inquiryCategoryInfo,
        }));
        return data;
    } catch (exception) {
        dispatch({
            type: Types.REQUEST_LIST_INQUIRY_ERROR,
            error: exception.message,
        });
    }
};

export const GET_INQUIRY_DETAIL = (payload) => async (dispatch) => {
  try {
   const data = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.INQUIRY}/getInquiryDetail/${payload.id}`);
   return data?.data?.data
  } catch (exception) {
    dispatch({
      type: Types.REQUEST_INQUIRY_DETAIL_ERROR,
      error:exception.message
    })
  }
}

export const GET_INQUIRY_ATTACHMENT = (payload) => async (dispatch) => {
  try {
   const data = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.INQUIRY}/getAttachmentByInquiryId/${payload.id}`);
   return data?.data?.data
  } catch (exception) {
    dispatch({
      type: Types.REQUEST_INQUIRY_DETAIL_ERROR,
      error:exception.message
    })
  }
}

export const GET_INQUIRY_COMMENT = (payload) => async (dispatch) => {
  try {
   const data = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.INQUIRY}/getCommentByInquiryId/${payload.id}`);
   return data?.data?.data
  } catch (exception) {
    dispatch({
      type: Types.REQUEST_INQUIRY_DETAIL_ERROR,
      error:exception.message
    })
  }
}

export const GET_INQUIRY_ACTIVITY_LOG = (payload) => async (dispatch) => {
  try {
   const data = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.INQUIRY}/getActivityLogByInquiryId/${payload.id}`);
   return data?.data?.data
  } catch (exception) {
    dispatch({
      type: Types.REQUEST_INQUIRY_DETAIL_ERROR,
      error:exception.message
    })
  }
}

export const CREATE_INQUIRY_COMMENT = (payload) => async (dispatch) => {
  try {
    const data = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.INQUIRY}/createComment`,payload);
   return data?.data?.data?.result
  } catch (exception) {
    dispatch({
      type: Types.CREATE_INQUIRY_COMMENT_ERROR,
      error:exception.message
    })
  }
}

export const UPDATE_INQUIRY_COMMENT = (payload) => async (dispatch) => {
  try {
   await AuthAxios.axios.patch(`${LOCAL_URL}${API_REQUESTS.INQUIRY}/updateComment/${payload.id}`,payload);

  } catch (exception) {
    dispatch({
      type: Types.UPDATE_INQUIRY_COMMENT_ERROR,
      error:exception.message
    })
  }
}


export const DELETE_INQUIRY_COMMENT = (payload) => async (dispatch) => {
  try {
   await AuthAxios.axios.delete(`${LOCAL_URL}${API_REQUESTS.INQUIRY}/deleteInquiryComment/${payload.id}`);
  } catch (exception) {
    dispatch({
      type: Types.UPDATE_INQUIRY_COMMENT_ERROR,
      error:exception.message
    })
  }
}

export const UPDATE_INQUIRY_STATUS = (payload) => async (dispatch) => {
  try {
   await AuthAxios.axios.patch(`${LOCAL_URL}${API_REQUESTS.INQUIRY}/updateStatus/${payload.id}`,payload);
  } catch (exception) {
    dispatch({
      type: Types.UPDATE_INQUIRY_STATUS_ERROR,
      error:exception.message
    })
  }
}

export const CREATE_NEW_INQUIRY = (payload) => async (dispatch) => {
  try {
    const data = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.INQUIRY}/createInquiry`, payload);
   return data?.data?.data?.data
  } catch (exception) {
    dispatch({
      type: Types.CREATE_NEW_INQUIRY_ERROR,
      error:exception.message
    })
  }
}

export const CREATE_GUEST_INQUIRY = (payload) => async (dispatch) => {
  try {
    const data = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.INQUIRY}/createGuestInquiry`, payload);
    return data?.data?.data?.data;
  } catch (exception) {
    dispatch({
      type: Types.CREATE_NEW_INQUIRY_ERROR,
      error: exception.message,
    });
  }
}

export const UPDATE_INQUIRY_DETAIL = (payload) => async (dispatch) => {
  try {
    const { id } = payload
    if (!id) {
      return
    }
    const data = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.INQUIRY}/updateInquiry`, payload);
    return data?.data?.data?.data
  } catch (exception) {
    dispatch({
      type: Types.UPDATE_INQUIRY_ERROR,
      error: exception.message
    })
  }
}

export const REOPEN_INQUIRY = (payload) => async (dispatch) => {
  try {
    const data = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.INQUIRY}/reopenInquiry`,payload);
    return data;
  } catch (exception) {
    dispatch({
      type: Types.REOPEN_INQUIRY_ERROR,
      error:exception.message
    })
  }
}

export const DELETE_INQUIRY_DOCUMENT = (payload) => async () => {
  try {
    const data = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.INQUIRY}/deleteDocument`, payload);
    return data;
  } catch (exception) {
    return exception;
  }
}

export const CREATE_INQUIRY_NOTIFICATION = (payload) => async (dispatch) => {
  try {
    const { id, type, actionType } = payload
    if (!id || !type || !actionType) {
      return
    }
    const data = await AuthAxios.axios.post(`${LOCAL_URL}${API_REQUESTS.INQUIRY}/createInquiryNotification`, payload);
    return data
  } catch (exception) {
    return exception;
  }
}